import { Outlet } from 'react-router-dom';

import { CartProvider } from '@zenbusiness/application-commons-ecommerce';
import { PriceListProvider } from '@zenbusiness/application-commons-pricelist';

import FLOW_CONFIG, { DEFAULT_FLOW_ID } from '#client/config/flowConfig';

import { useNotification } from './NotificationManager';

export default function DevToolProviders({ children }) {
  const defaultFlowConfig = FLOW_CONFIG.find((config) => config.id === DEFAULT_FLOW_ID);
  const priceListUuid = defaultFlowConfig?.priceListUuids?.development;
  const { onError } = useNotification();

  const cartProviderProps = {
    anonymous: true,
    priceListUuid,
    tracking: {
      flowName: 'dev-tools',
      flowVersion: '1',
      purchaseSource: 'shop'
    },
    onError
  };

  return (
    <CartProvider {...cartProviderProps}>
      <PriceListProvider priceListUuid={priceListUuid}>{children || <Outlet />}</PriceListProvider>
    </CartProvider>
  );
}
